import {
    FETCH_SUBSCRIPTION_STATUS_SUCCEEDED,
    SIGN_OUT_SUCCEEDED,
} from 'shared_redux/actions';

import { Model, attr } from 'redux-orm';

class Subscriptions extends Model {

    static reducer(action, Subscriptions, session) {
        switch (action.type) {
            case FETCH_SUBSCRIPTION_STATUS_SUCCEEDED:
                if (action.subscriptionData && action.subscriptionData.organizationId) {
                    Subscriptions.upsert({
                        organization_id: action.subscriptionData.organizationId,
                        ...action.subscriptionData
                    });
                }
                break;
            case SIGN_OUT_SUCCEEDED:
                Subscriptions.all().delete();
                break;
        }
    }

}
Subscriptions.modelName = 'Subscriptions';

Subscriptions.options = {
    idAttribute: 'organization_id',
};

Subscriptions.fields = {
    organization_id: attr(),
    hasSubscription: attr(),
    hasActiveBenefits: attr(),
    status: attr(),
    currentPeriodEnd: attr(),
    cancelAtPeriodEnd: attr(),
    cancelAt: attr(),
};

export default Subscriptions;
